import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import { useStyledBlock, StyleControls } from "./StyleControls";
import type { BlockSettingsTabProps } from "./BreakpointSwitcher";

type SpacerProps = { height: number };

export function SpacerBlockSettings({ tab, breakpoint }: BlockSettingsTabProps) {
  const { props, setProp, style, updateStyle } = useStyledBlock<SpacerProps>();

  if (tab === "content") {
    return (
      <div className="space-y-1">
        <Label className="text-xs">Height ({props.height ?? 32}px)</Label>
        <Slider
          value={[props.height ?? 32]}
          max={200}
          step={4}
          onValueChange={([v]) => setProp((p) => { p.height = v; })}
        />
      </div>
    );
  }
  if (tab === "style") {
    return <StyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} showBackground={false} />;
  }
  return <p className="text-xs text-muted-foreground">No advanced settings.</p>;
}
